module.exports = __webpack_public_path__ + "static/media/uniformwidget.539e6e5e.svg";